module.exports = __webpack_public_path__ + "img/icon.f7fcb40f.svg";